<template>
  <div class="agents">
    <AppHeader logoLink="/" />
    <div class="common-title__border-bottom">
      <h1>Meet Our Agents</h1>
    </div>
    <div class="list" v-if="list.length">
      <div
        class="list-item"
        v-for="agent in list"
        :key="agent.id"
        @click="goDetail(agent.username)"
      >
        <div
          class="list-item--photo"
          v-lazy:background-image="getAvatarImg(agent)"
          v-if="getAvatarImg(agent)"
        ></div>
        <div class="list-item--name">{{ agent.nickname }}</div>
        <div class="list-item--title">{{ agent.title || 'Premier agent' }}</div>
        <div class="list-item--dre" v-if="agent.dre.length">DRE #{{ agent.dre }}</div>
        <div
          class="list-item--language"
          v-if="agent.language && agent.language.length"
        >Language: {{ getLanguage(agent.language) }}</div>
      </div>
    </div>
    <div class="list__empty" v-else>No data available</div>
    <div class="agents-pager" v-if="false">
      <el-pagination
        class="pager"
        v-if="list.length"
        background
        :current-page.sync="page"
        :page-size="pageSize"
        layout="pager"
        :total="total"
      ></el-pagination>
    </div>
    <AddonBuyerReso class="addon" />
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from '../components/AppHeader'
import AppFooter from '../components/AppFooter'
import AddonBuyerReso from '../components/AddonBuyerReso'
import scroll2top from '@/common/scroll2top'
import processImage from '@/common/processImage'

export default {
  components: { AppHeader, AppFooter, AddonBuyerReso },
  data () {
    return {
      list: [],
      page: Number(this.$route.params.page) || 1,
      pageSize: 12,
      total: 100,
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      const params = {}
      // params.limit = this.pageSize
      // params.skip = (this.page - 1) * params.limit

      this.$axios({
        url: '/api/v1/client/estate/getAgentList',
        method: 'get',
        params,
      })
        .then(res => {
          this.list = res.users
          this.total = res.total
        })
        .catch(err => {
          console.error(err)
        })
    },
    goDetail (username) {
      location.href = `/agent/${username}`
    },
    getAvatarImg (agent) {
      if (agent && agent.avatar && agent.avatar.url) {
        return processImage.processImage(agent.avatar.url, { resize: 'mid' })
      }
      if (agent.avatar) {
        return processImage.processImage(agent.avatar, { resize: 'mid' })
      }
      return false
    },
    getLanguage (language) {
      let lang = []
      language.forEach(item => {
        lang.push(item.slice(0, 1).toUpperCase() + item.slice(1))
      })
      return lang.join(', ')
    },
  },
  watch: {
    page: {
      immediate: false,
      handler: function (val) {
        this.page = val
        this.$router.push({ name: 'agents', params: { page: val } })
        this.getList()
        scroll2top(300)
      },
    },
  },
}
</script>
<style lang="less" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  width: 904px;
  margin: 128px auto 0;
  padding-bottom: 80px;

  .list-item {
    margin-right: 160px;
    margin-top: 138px;
    cursor: pointer;
    width: 370px;
    height: 233px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
    border-radius: 4px;

    &:nth-child(2n + 2) {
      margin-right: 0;
    }

    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 0;
    }

    .list-item--photo {
      margin-top: -80px;
      margin-left: 20px;
      width: 246px;
      height: 182px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top;
      background-color: #fafafa;
    }

    .list-item--name {
      margin-top: 15px;
      padding: 0 0 0 16px;
      color: #333;
      width: 250px;
      height: 22px;
      font-size: 18px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
    }

    .list-item--title {
      margin-top: 12px;
      padding: 0 0 0 16px;
      font-size: 12px;
      width: 354px;
      height: 17px;
      color: rgba(51, 51, 51, 1);
      line-height: 17px;
    }

    .list-item--dre {
      margin-top: 12px;
      padding: 0 0 0 16px;
      width: 354px;
      height: 14px;
      font-size: 12px;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
    }

    .list-item--language {
      margin-top: 12px;
      padding: 0 0 0 16px;
      width: 354px;
      height: 14px;
      font-size: 12px;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
    }
  }
}

.list__empty {
  text-align: center;
  padding: 50px 0;
}

.agents-pager {
  text-align: center;
  padding: 47px 0 33px;
}
</style>
